import { stringToEnum } from '@snap-types/util/enum';

export enum CalculationMode {
  DEFAULT = 'default',
  BATCH_WEIGHT = 'batch-weight',
  BATCH_QUANTITY = 'batch-quantity',
  LOT = 'lot',
}

export const calculationModeSchema = stringToEnum(CalculationMode);
